import type { ReactNode } from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

interface BlogLayoutProps {
  children: ReactNode;
}

export default function BlogLayout({ children }: BlogLayoutProps) {
  return (
    <>
      <SiteHeader variant="solid" />

      {/* ===== CONTENT ===== */}
      <main className="blog-layout-main">
        {children}
      </main>

      <SiteFooter />
    </>
  );
}
